import ActiveRecordResource from './ActiveRecordResource';
import {AwsVideo} from './videoAws';

import config from 'config';

import { ImageDTO, Image } from "./image";




export interface CompetitionDTO{
  id: string;
  name: string;
  image_url: ImageDTO;

  video_url?: string;

  description: string;
  start_time: number;
  end_time: number;
  number_of_winners: number;
  statistics: {
    participated_last_24_hours: number
    participated_total: number
  }
  winners: {
    first_name: string
    last_name: string
    email: string
  }[]
}

export interface ICompetitionEditForm {
  id: string;
  name: string;
  image: Image;
  description: string;
  start_time: Date;
  end_time: Date;
  number_of_winners: number;

  video?: any;

}

export default class Competition extends ActiveRecordResource {
  
  name: string;
  image: Image;
  description: string;
  number_of_winners: number;
  start_time: Date;
  end_time: Date;
  video: AwsVideo;

  statistics: {
    participated_last_24_hours: number
    participated_total: number
  }

  winners: {
    first_name: string
    last_name: string
    email: string
  }[]
  
  static path = `${config.backOfficeBasePath}/raffles`;
  
  static validateConstraints = {
    image: {
      presence: true
    },
    name: {
      presence: true
    },
    number_of_winners: {
      presence: true
    },
    description: {
      presence: true
    },
    start_time: {
      presence: true
    },
    end_time: {
      presence: true,
      greaterThan: { key: 'start_time' }
    }
  };

  static mapRecords(data:CompetitionDTO[]) {
    return data.map((item) => Object.assign(new Competition(item), this.parseData(item)));
  }

  static parseData(data: CompetitionDTO) {
    data = Object.assign({}, this, data)
    return {
      name: data.name,
      image: data.image_url ? new Image(Object.assign(new ImageDTO(), data.image_url)) : null,
      description: data.description,
      number_of_winners: data.number_of_winners,
      start_time: new Date(data.start_time),
      end_time: new Date(data.end_time)
    }
  }
  
  _parseData(data: CompetitionDTO) {
    let res: any = {
      id: data.id,
      name: data.name,
      image: data.image_url ? new Image(Object.assign(new ImageDTO(), data.image_url)) : null,
      video: data.video_url ? new AwsVideo({isSaved: true, url: data.video_url}) : null,
      description: data.description,
      number_of_winners: data.number_of_winners,
      start_time: new Date(data.start_time),
      end_time: new Date(data.end_time),
      statistics: data.statistics,
      winners: data.winners
    };

    return res;
  }

  _getModel() {
    return Competition;
  }

  prepareForSave(data: ICompetitionEditForm) {

    let { name, image, description, start_time, end_time, number_of_winners } = data;
    return {
      name, description, number_of_winners,
      start_time: start_time ? start_time.getTime() : undefined,
      end_time: end_time ? end_time.getTime() : undefined,
      video_url: data.video ? data.video.url : undefined,
      ...{ image: (image && !image.isSaved) ? image.file : undefined }
    };
    

    
  }

  
  // async publish() {
  //   let response = await this._networkLayer.postJson(this._prepareUrl(this.id) + '/publish');

  //   let data = await response.json();

  //   this._extendData(data);

  //   return this;

  // }

}



// WEBPACK FOOTER //
// ./src/api/competition.ts